// Parser de CSV no cliente: espelha o escaping do `exportToCsv` (aspas com `""`
// escapadas, campos com separador/quebra entre aspas). Detecta `;` ou `,` como
// separador a partir do cabeçalho e devolve uma linha de objetos (cabeçalho →
// valor). Tolerante a BOM e a `\r\n` / `\n`.

export interface ParsedCsv {
  headers: string[];
  rows: Record<string, string>[];
}

const detectDelimiter = (headerLine: string): string => {
  let inQuotes = false;
  let semicolons = 0;
  let commas = 0;

  for (let i = 0; i < headerLine.length; i++) {
    const char = headerLine[i];
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if (!inQuotes && char === ";") {
      semicolons++;
    } else if (!inQuotes && char === ",") {
      commas++;
    }
  }

  return semicolons > commas ? ";" : ",";
};

const parseRecords = (text: string, delimiter: string): string[][] => {
  const records: string[][] = [];
  let field = "";
  let record: string[] = [];
  let inQuotes = false;

  for (let i = 0; i < text.length; i++) {
    const char = text[i];

    if (inQuotes) {
      if (char === '"') {
        if (text[i + 1] === '"') {
          field += '"';
          i++;
        } else {
          inQuotes = false;
        }
      } else {
        field += char;
      }
      continue;
    }

    if (char === '"') {
      inQuotes = true;
    } else if (char === delimiter) {
      record.push(field);
      field = "";
    } else if (char === "\n") {
      record.push(field);
      records.push(record);
      field = "";
      record = [];
    } else if (char !== "\r") {
      field += char;
    }
  }

  if (field.length > 0 || record.length > 0) {
    record.push(field);
    records.push(record);
  }

  return records;
};

export const parseCsv = (text: string): ParsedCsv => {
  const clean = text.replace(/^\uFEFF/, "");
  if (!clean.trim()) return { headers: [], rows: [] };

  const firstBreak = clean.search(/\r?\n/);
  const headerLine = firstBreak === -1 ? clean : clean.slice(0, firstBreak);
  const delimiter = detectDelimiter(headerLine);

  const records = parseRecords(clean, delimiter).filter((row) =>
    row.some((cell) => cell.trim() !== "")
  );
  if (records.length === 0) return { headers: [], rows: [] };

  const headers = records[0].map((header) => header.trim());
  const rows = records.slice(1).map((cols) => {
    const row: Record<string, string> = {};
    headers.forEach((header, index) => {
      row[header] = (cols[index] ?? "").trim();
    });
    return row;
  });

  return { headers, rows };
};
